import { createSelector } from '@reduxjs/toolkit';
import { selectSaleTypes } from 'shared/selectors/jsonQuery';
import { prepareValue } from './utils';
import { FLAT_OLD_SALE_TYPES } from 'shared/constants/saleTypeValues';

export const selectFlatOldSaleTypeValue = createSelector(selectSaleTypes, value =>
  prepareValue({ value, allowedValues: FLAT_OLD_SALE_TYPES }),
);
